export default {
    type: 'set',
    format: {
        searchOnly: true
    },
    default: {
        logic: 'match',
        tolerance: 2,
        operand: '>=',
        value: []
    },
    setting: {
        logic: ['match', 'oneof', 'someof', 'allof']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Games',
        category: 'Game',
        description: 'Specific games.',
        summarise: {
            prefix: 'Game'
        },
        unit: 'game'
    }
}